<template>
  <div class="fac-event">
    <h2 class="sub-heading">この施設付近のイベント</h2>
    <div class="panel-thumb-wrapper">
      <kcs-event-list-item
        v-for="(event, index) in events"
        :key="index"
        :event="event"
        @click.native="
          handleAnalyticsTrackEvent('facility_detail', 'click', 'event_link', 1)
        "
      />
    </div>
    <kcs-btn
      :url="url"
      :external="true"
      @click.native="
        handleAnalyticsTrackEvent('facility_detail', 'click', 'event_more', 1)
      "
      name="イベントをもっと見る"
    />
  </div>
</template>

<script>
import KcsEventListItem from '@/components/molecules/kcs-event-list-item.vue'
import KcsBtn from '@/components/atoms/kcs-btn.vue'
export default {
  components: {
    KcsEventListItem,
    KcsBtn
  },
  props: {
    events: {
      type: Array,
      required: true
    },
    detail: {
      type: Object,
      required: true
    }
  },
  computed: {
    url() {
      return 'https://www.kokuchpro.com/facility/' + this.detail.code + '/'
    }
  }
}
</script>
